import { render, staticRenderFns } from "./adverts.vue?vue&type=template&id=37b440dc"
import script from "./adverts.vue?vue&type=script&lang=ts"
export * from "./adverts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports